import { ICellRendererParams, ICellRendererComp } from 'ag-grid-community'
import { ValueGetterMapper } from 'selectors/negotiations'
import { hasNegotiations } from './negotiationDataUtil'

interface TargetCellRenderer extends ICellRendererComp {
  new (): any
}

export interface INegotiationPivotedRowCellRendererParams extends ICellRendererParams {
  targetCellRenderer: TargetCellRenderer
  valueMapper: ValueGetterMapper
}

export class NegotiationPivotedRowCellRenderer implements ICellRendererComp {
  private eGui: HTMLElement | null = null
  private targetCellRenderer: TargetCellRenderer | null = null
  private valueMapper: ValueGetterMapper | null = null

  public init(params: INegotiationPivotedRowCellRendererParams) {
    this.eGui = document.createElement('div')
    const { targetCellRenderer: TargetCellRendererClass, valueMapper } = params

    this.valueMapper = valueMapper

    const mappedParams = this.valueMapper(params)

    if (TargetCellRendererClass && mappedParams.data && !hasNegotiations(mappedParams.data)) {
      const targetCellRenderer = new TargetCellRendererClass()
      this.targetCellRenderer = targetCellRenderer
      targetCellRenderer.init(mappedParams)
    } else {
      this.refresh(params)
    }
  }

  public getGui(): HTMLElement {
    if (!this.eGui) {
      throw new Error('eGui is not set')
    }

    if (this.targetCellRenderer) {
      return this.targetCellRenderer.getGui()
    }

    return this.eGui
  }

  public refresh(params: INegotiationPivotedRowCellRendererParams): boolean {
    const mappedParams = this.valueMapper!(params)

    if (this.targetCellRenderer) {
      return this.targetCellRenderer.refresh(mappedParams)
    } else if (this.eGui) {
      return true
    } else {
      throw new Error('cell has not been initialised')
    }
  }

  public destroy() {
    if (this.targetCellRenderer && this.targetCellRenderer.destroy) {
      this.targetCellRenderer.destroy()
    } else {
      this.eGui = null
    }
  }
}
